'use client';
import Image, { type ImageProps } from 'next/image';
import { cloudflareLoader } from '@/utils/images/cloudflare-loader';

/** next/image for tone images and avatars. Client-side because a loader is a function prop. */
const AssetImage = (props: Omit<ImageProps, 'loader' | 'quality'>) => (
  <Image {...props} loader={cloudflareLoader} />
);

export default AssetImage;
